interface ChatProps {
    size?: number
}

const Chat = ({ size = 19 }: ChatProps) => (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18 8.2372C18 4.24791 14.1835 1 9.5 1C4.8165 1 1 4.24791 1 8.2372C1 11.81 4.02317 14.8086 8.10883 15.3771C9.10333 15.6028 8.98905 15.9853 8.76617 17.3916C8.72933 17.6164 8.59239 18.2718 9.5 17.8751C10.4067 17.4785 14.3922 14.852 16.1801 12.6996C17.4116 11.2792 18 9.83896 18 8.24664V8.2372Z"
            stroke="#181818"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default Chat
